import React from 'react';
import styled from 'styled-components';
import { PageHeader } from '@grnhse/seedling/lib/azalea/typography';
import { withLocalePrefix } from 'shared/utils/translation';
import BackButton from './back_button';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack';
import { MainHeader } from '@grnhse/bonsai/lib/components/typography';

const t = withLocalePrefix('self_schedule.candidate_view');

type Props = {
  page?: number;
  goBack: () => void;
  isReschedule: boolean;
  bonsaiEnabled: boolean;
};

function titleForPage(page: number, isReschedule: boolean): string {
  switch (page) {
    case 1:
      return t('additional_details');
    default:
      return isReschedule ? t('reschedule_title') : t('title');
  }
}

const Title = (props: Props) => {
  const titleText = titleForPage(props.page || 0, props.isReschedule);

  if (props.bonsaiEnabled) {
    return (
      <BonsaiHeaderWrapper>
        <Stack spacing={1}>
          <BackButton
            page={props.page}
            goBack={props.goBack}
            bonsaiEnabled={props.bonsaiEnabled}
          />
          <MainHeader>{titleText}</MainHeader>
        </Stack>
      </BonsaiHeaderWrapper>
    );
  }

  return (
    <StyledPageHeader>
      {props.page === 1 && (
        <BackButton
          page={props.page}
          goBack={props.goBack}
          bonsaiEnabled={props.bonsaiEnabled}
        />
      )}
      {titleText}
    </StyledPageHeader>
  );
};

const StyledPageHeader = styled(PageHeader)`
  margin: 65px auto 42px;

  @media only screen and (max-width: 1024px) {
    margin: 35px auto 10px;
    padding: 0 60px;
  }

  @media only screen and (max-width: 480px) {
    padding: 0 35px;
  }
`;

const BonsaiHeaderWrapper = styled.div`
  margin: 65px auto 42px;

  @media only screen and (max-width: 1024px) {
    margin: 35px auto 10px;
    padding: 0 60px;
  }

  @media only screen and (max-width: 480px) {
    padding: 0 35px;
  }
`;

export default Title;
